import styled from 'styled-components';
import { unthemed } from 'tokens';

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	max-width: 1200px;

	// i spent a lot of time trying to make the video player behave well for both tall and wide screens
	// in the end, i ended up using this switch to change the layout based on screen aspect ratio
	//
	// ... and then i noticed that, on small screens, the min-aspect-ratio needs to be closer to 1 (around 5/4)
	// to avoid hiding the controls.
	// ... and on even larger screens (say 2000px) the min-aspect-ratio needs to be closer to 2 to avoid aggressively
	// applying this height rule too early (leading to the video having a big pillarboxs).
	// After playing around with things a bit, i decided to put in rules for various sizes.
	// This requires manual tweaking but seems to be enough to put this to bed.
	// If this doesn't work well, I advise yet more manual tweaking. What we're doing here really doesn't seem to
	// play nice with CSS/etc.

	@media (min-width: 1600px) {
		@media (min-aspect-ratio: 20/9) {
			height: 85vh;
		}
	}

	@media (min-width: 1200px) and (max-width: 1599px) {
		@media (min-aspect-ratio: 10/9) {
			height: 85vh;
		}
	}

	@media (min-width: 800px) and (max-width: 1199px) {
		@media (min-aspect-ratio: 10/9) {
			height: 85vh;
		}
	}

	@media (max-width: 799px) {
		@media (min-aspect-ratio: 5/4) {
			height: 85vh;
		}
	}
`;

export const Onboarding = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const OnboardingTitle = styled.div`
	font-size: 24px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray['1000']};
	text-align: center;
`;

export const OnboardingDescription = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray['1000']};
	text-align: center;
`;

export const Video = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
`;

export const Placeholder = styled.div`
	flex: 1 1 auto;
	min-height: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${unthemed.red['500']};
`;

export const VideoHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: ${unthemed.gray['1000']};
	padding: 8px 12px;
	flex: 1;
	flex-grow: 0;
	width: 100%;
	box-sizing: border-box;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
`;

export const VideoTitle = styled.h3`
	margin: 0;
	font-size: 15px;
	font-weight: 500;
	color: ${unthemed.gray['100']};
`;

export const VideoDescription = styled.p`
	margin: 0;
	font-size: 14px;
	color: ${({ theme }) => theme.gray['1000']};
	line-height: 1.4;
`;

export const CompletedBadge = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-size: 12px;
	color: ${unthemed.gray['100']};
	font-weight: 600;
	border-radius: 4px;
`;

export const ContinueButton = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const VideoContainer = styled.div`
	position: relative;
	flex: 1;
	min-height: 0;
`;

export const EndOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10;
`;

export const EndOverlayContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
	padding: 32px;
	background: ${unthemed.gray[1000]};
	border-radius: 4px;
	max-width: 400px;
	text-align: center;
`;

export const EndOverlayTitle = styled.div`
	font-size: 20px;
	font-weight: 600;
	color: ${unthemed.gray[100]};
`;

export const EndOverlayButtons = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
`;
